<template>
  <div class="upload-message">
    <upload-drag-and-drop
      v-if="isLatestMessage"
      :message="message"
      @submit="setFiles"
    />
    <button
      v-if="isLatestMessage"
      type="button"
      class="quick-reply-button upload-message__button"
      :disabled="isButtonDisabled"
      @click="onButtonClick"
    >
      {{ buttonTitle }}
    </button>
  </div>
</template>

<script>
// @flow

import { mapGetters } from 'vuex'

import { CHATBOT_EVENTS, dispatchChatchampEvent } from '../../../../main/eventTracking'

import { sendUploadedFile } from '../../../utils/api'

import UploadDragAndDrop from './UploadDragAndDrop.vue'

export default {
  components: {
    UploadDragAndDrop
  },
  props: {
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  data: () => {
    return {
      files: []
    }
  },
  computed: {
    ...mapGetters(['latestMessage']),
    buttonTitle () {
      return this.message.content.buttonTitle || 'Continue'
    },
    isButtonDisabled () {
      if (!this.isLatestMessage) return true
      if (!this.message.content.isRequired) return false

      return this.files.length === 0
    },
    isLatestMessage () {
      return this.latestMessage && this.latestMessage.id === this.message.id
    }
  },
  methods: {
    async onButtonClick () {
      const { attribute } = this.message.content
      const value = this.files.map(f => f.url).join(', ')
      await sendUploadedFile(value, this.buttonTitle, this.message.content.messageId)
      await this.$store.dispatch('addTextMessageToList', this.buttonTitle)
      if (attribute) dispatchChatchampEvent(CHATBOT_EVENTS.AttributeSet, { ...attribute, value })
    },
    setFiles (files) {
      this.files = files
    }
  }
}
</script>

<style src="./upload-message.scss" />
